/*
 * @Author: Zhouqi
 * @Date: 2025-11-03 14:08:30
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-12 14:21:04
 */
import Image from 'next/image';
import { useRouter } from 'next/router';
import { memo, useCallback, useMemo, useState } from 'react';

import { useRouteChange } from '@/hooks/useRouteChange';
import { useTranslate } from '@/hooks/useTranslate';
import { ROUTE_FROM } from '@/utils/const';
import { EventNewID, PageVisitFrom } from '@/utils/eventlog/eventNewConfig';
import { trackEvent } from '@/utils/eventlog/logAdapter';
import {
  aiRemovalURL,
  aiVideoEditURL,
  faceSwapperURL,
  PageTabParam,
  productAvatarURL,
  voiceCloneURL,
} from '@/utils/router';

import ViewMore from '../view-more';
const COLLAPSED_COUNT = 4;

const PopularTool = memo(() => {
  const { t } = useTranslate();
  const { navigate } = useRouteChange();
  const router = useRouter();
  const [expanded, setExpanded] = useState(false);

  const tools = useMemo(
    () => [
      {
        id: 'viral-remake',
        title: t('f.viralRemake'),
        image: '/images/3.0-adClone.png',
        navigateURL: '',
        isNew: true,
        allowRouterPush: false,
      },
      {
        id: 'ai-removal',
        title: t('bc.removal'),
        image: '/images/3.0-ai-removal.png',
        navigateURL: aiRemovalURL,
      },
      {
        id: 'product-avatar',
        title: t('Product-avatar-video'),
        image: '/images/3.0-productAvatar.png',
        navigateURL: productAvatarURL,
      },
      {
        id: 'face-swap',
        title: t('2-0'),
        image: '/images/3.0-faceSwap.png',
        navigateURL: faceSwapperURL,
      },
      {
        id: 'voice-clone',
        title: t('ce24a821ce9a84f071a4b291570d64b6'),
        image: '/images/3.0-voiceClone.png',
        navigateURL: voiceCloneURL + `?tab=${PageTabParam.VOICE_CLONE}`,
      },
      {
        id: 'video-edit',
        title: t('9613af8a82f375ffce54844fc0a470cc'),
        image: '/images/3.0-videoEdit.png',
        navigateURL: aiVideoEditURL,
      },
    ],
    [t],
  );

  const visibleTools = useMemo(
    () => (expanded ? tools : tools.slice(0, COLLAPSED_COUNT)),
    [expanded, tools],
  );
  const hasMore = tools.length > COLLAPSED_COUNT;

  const navigateTo = useCallback(
    (url: string, index: number) => {
      trackEvent(EventNewID.RECOMMEND_CLICK, { position_id: index });
      if (!url) return;
      sessionStorage.setItem(ROUTE_FROM, PageVisitFrom.HOME_CLICK);
      navigate(() => {
        router.replace(url);
      });
    },
    [navigate, router],
  );

  return (
    <div className="flex flex-col items-center gap-[16px] w-full">
      <div className="flex flex-wrap gap-[16px] w-full">
        {visibleTools.map(({ id, navigateURL, title, image, isNew }, index) => (
          <div
            key={id}
            className="flex flex-col gap-[16px] p-[12px] rounded-[12px] bg-[#F6F9FF] cursor-pointer transition-all duration-200 border-2 border-solid border-transparent hover:bg-[#F3EFFF] hover:border-[#745CFF] hover:shadow-[0px_4px_8px_rgba(59,0,106,0.12)] hover:translate-y-[-4px] active:scale-[0.97] active:shadow-[0px_2px_4px_rgba(59,0,106,0.08)] relative"
            style={{ width: 'calc(25% - 12px)' }}
            onClick={() => navigateTo(navigateURL, index + 1)}
          >
            {isNew && (
              <div className="absolute top-[14px] right-[10px] bg-gradient-to-b from-[#FFA65E] to-[#FF5100] rounded-[12px] px-[8px] py-[2px] h-[16px] flex items-center justify-center">
                <span className="text-[10px] font-[400] text-white leading-[12px]">
                  {t('home.comingSoon')}
                </span>
              </div>
            )}
            <span className="text-[14px] font-[500] text-black leading-[20px]">
              {title}
            </span>
            <div className="relative w-full h-[122px] rounded-[6px] overflow-hidden">
              <Image src={image} alt={title} fill className="object-cover" />
            </div>
          </div>
        ))}
      </div>

      {hasMore && <ViewMore expanded={expanded} onExpand={setExpanded} />}
    </div>
  );
});

export default PopularTool;
